import React from 'react';

const IconLoader = () => (
	  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(40.000000, 35.000000)">
        <path d="M 0 31.349 L 0 26.383 A 24.247 24.247 0 0 0 4.669 28.009 A 19.797 19.797 0 0 0 9.272 28.603 Q 12.393 28.603 13.876 27.416 Q 15.359 26.23 15.359 24.23 Q 15.359 22.428 13.997 21.176 A 19.716 19.716 0 0 0 8.635 18.316 A 62.679 62.679 0 0 0 8.372 18.21 A 14.881 14.881 0 0 1 2.175 14.145 Q 0.374 11.86 0.374 8.652 A 7.693 7.693 0 0 1 3.23 2.323 A 11.849 11.849 0 0 1 10.898 0.016 A 22.531 22.531 0 0 1 20.083 2.038 L 18.413 6.322 Q 14.128 4.521 10.767 4.521 Q 8.218 4.521 6.899 5.63 Q 5.581 6.74 5.581 8.564 A 4.13 4.13 0 0 0 6.108 10.706 Q 6.636 11.596 7.844 12.387 Q 9.053 13.178 12.195 14.474 Q 15.732 15.946 17.38 17.221 Q 19.028 18.495 19.797 20.099 Q 20.566 21.703 20.566 23.879 Q 20.566 28.163 17.468 30.602 Q 14.37 33.041 8.921 33.041 A 20.394 20.394 0 0 1 0 31.349 Z" fill="currentColor">
      </path>
      </g>
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
